import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import FormComponent from '../FormComponent';
import SearchInputField from '../SearchInputField';
import { InputTypes } from '../../utils/validateFormElement';

const CLICK_EVENT = 'click';

const HIDDEN_CLASS = 'u-hidden';

class DBSVenueFinder extends FormComponent {
	constructor(element, config) {
		super(element, config);
	}
	markup(value, rowData, titleMarkup) {
        return `
            <div class="dbs-venue-finder">
				<div class="dbs-venue-finder-title u-fw-bold u-mb-1">Please select your venue</div>
                <div class="dbs-venue-finder--search-input-wrapper">
					<div class="dbs-venue-finder--search-input u-mb-2"></div>
				</div>
				<div class="dbs-venue-finder--search-result u-hidden"></div>
            </div>
        `;
	}
	afterRender() { 
		this.dbsVenueFinderElement = SelectorEngine.findOne('.dbs-venue-finder', this.containerEl);
		this.dbsVenueTitle = SelectorEngine.findOne('.dbs-venue-finder-title', this.dbsVenueFinderElement);
		this.dbsVenueSearchInputWrapper = SelectorEngine.findOne('.dbs-venue-finder--search-input-wrapper', this.dbsVenueFinderElement)
		this.dbsVenueSearchInput = SelectorEngine.findOne('.dbs-venue-finder--search-input', this.dbsVenueSearchInputWrapper);
		this.dbsVenueSearchResult = SelectorEngine.findOne('.dbs-venue-finder--search-result', this.dbsVenueFinderElement);

		this.initSearchInputField();
	}
	initSearchInputField() {
		this.searchInputTextField = new SearchInputField(this.dbsVenueSearchInput, {
			data: this.data,
            titleMarkup: 'sadasdads'
		});

        this.searchInputTextField.dataMapping = item => {
			return {
				firstLineText: item.organisationName,
				secondLineText: `${item.organisationPostCode}, ${item.organisationMembershipNumber}`,
				dataKey: this.data.dataKey,
				dataValue: item.organisationShortCode
			}
		}

		this.searchInputTextField.filterDataMapping = (item, event) => {
			return item.organisationShortCode === event[this.data.dataKey];
		}
		this.searchInputTextField.searchInputMappingChange();
		this.searchInputTextField.onChange((event) => {
			this.loadVenueResult(event.value, true)
		});
		this.setupValidateObject();
		if(this.data?.value) {
			this.loadVenueResult(this.data?.value, false);
		}
	}
	loadVenueResult(resultDetails, isSetupValueObject) {
		if(isSetupValueObject) {
			this.setupValueObject(resultDetails, "Complete");
		}
		if(!resultDetails?.organisationName){
			return;
		}
		this.dbsVenueSearchInputWrapper.classList.add(HIDDEN_CLASS);
		this.dbsVenueTitle.classList.add(HIDDEN_CLASS);
		this.dbsVenueSearchResult.classList.remove(HIDDEN_CLASS);
		this.dbsVenueSearchResult.insertAdjacentHTML('beforeend', this.renderAutoSuggestResult(resultDetails));
		this.afterAutoSuggestResultRender();
	}
	setupValueObject(value, obBoardingStatus) {
		this.value = {
			...this.data,
			value: value ? {
				...value,
				onboardingStatus: obBoardingStatus
			} : undefined
		}
		if(this.value) {
			this.dependentQuestion = this.value.dependentQuestion;
		}
	}
	afterAutoSuggestResultRender() {
		const suggestionAutoSuggestResult = SelectorEngine.findOne('.lta-autosuggest-input-result', this.dbsVenueSearchResult);
		const searchAgainButton = SelectorEngine.findOne('.dbs-venue-search--again', suggestionAutoSuggestResult);

		EventHandler.on(searchAgainButton, CLICK_EVENT, () => {
			suggestionAutoSuggestResult.remove();
			this.dbsVenueSearchInputWrapper.classList.remove(HIDDEN_CLASS);
			this.dbsVenueTitle.classList.remove("u-hidden");
			this.dbsVenueSearchResult.classList.add(HIDDEN_CLASS);
		});
	}
	renderAutoSuggestResult(venue) {
		return `<div class="lta-autosuggest-input-result">
					<p class="lta-text-input__label">Your venue</p>
					<div class="u-px-3 u-py-2 u-bg-background-blue u-rounded">
                        <div class="lta-autosuggest-input-result_venue-name u-h6 u-mb-1">${venue.organisationName}</div>
						<div class="u-body2 u-mb-2">
							<p class="lta-autosuggest-input-result_venue-number u-hidden">${venue.organisationShortCode}</p>
                            <p class="lta-autosuggest-input-result_venue-number">Membership Number: ${venue.organisationMembershipNumber}</p>
							<p class="lta-autosuggest-input-result_venue-postcode">Postcode: ${venue.organisationPostCode}</p>

						</div>  
						<button type="button" class="lta-btn lta-btn--xs lta-btn--petite lta-btn--icon lta-btn--icon-before dbs-venue-search--again">
							<svg class="lta-icon js-lta-text-input--btn-icon u-mr-0" width="1.5em" height="1.5em" fill="currentColor" alt="search" aria-hidden="true">
								<use xlink:href="/static/images/icons/lta-icons.svg#search"></use>
							</svg>Search again
						</button>
					<div>
				</div>`;
	}
	renderInstructionLabel(instructionLabel) {
		return instructionLabel ? `<span class="lta-text-input__label-instruction">${instructionLabel}</span>` : '';
	}
	setupValidateObject() {
		this.formElementData = {
			element: this.searchInputFieldContainerElement,
			formElement: this.searchInputFieldElement,
			errorMessage: 'Please select the venue',
			inputType: InputTypes.SELECTOR_INPUT,
			hasIcon: false
		}
	}
	validate() {
		this.searchInputTextField.validate();
	}
}
export default DBSVenueFinder;
